import { useSelector } from 'react-redux';

export function useMobileCheck() {
  const isMobile = useSelector((state) => state.navigation.breakpoint);
  return isMobile;
}
